import { useAtom } from "jotai";

import { $fileWatcherEffect } from "../../internal/file-watcher";

/**
 * Hook that mounts the file watcher effect.
 *
 * Call this once at app startup to subscribe to external file changes. When markdown files
 * are modified externally (e.g., by Amp CLI), this effect applies the changes to the
 * corresponding ProseMirror editor states.
 */
export const useFileWatcherLoader = () => {
	useAtom($fileWatcherEffect);
};
